import React, { useEffect, useState } from "react";
import ServiceCard from "Components/ServiceCard";
import { Link } from "react-router-dom";
import * as api from 'API/api'

const Services = () => {
  const [serviceData, setServiceData] = useState([]);

  useEffect(() => {

    const loadServices = async () => {
      const services = await api.fetchServices();
      setServiceData(services);
      console.log(services);
    }
    loadServices();
  }, []);

  return (
    <main className=" bg-gray-50">
      <section className="border-b bg-white">
        <div className="mx-auto max-w-6xl px-4 py-10">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">
            Our Services
          </h1>
          <p className="mt-2 max-w-2xl text-gray-600">
            Trusted Wrench offers fast, reliable auto care—from routine maintenance
            to diagnostics.
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            <div className="rounded-xl bg-blue-900 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-800">
              <Link to="/appointments">Book an Appointment</Link>
            </div>

            <a
              href="/quote"
              className="rounded-xl border border-gray-300 bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-50"
            >
              Get a Quote
            </a>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {(Array.isArray(serviceData) ? serviceData : []).map((service) => (
            <ServiceCard key={service.serviceId} service={service} />
          ))}
        </div>
      </div>

      <section className="mx-auto max-w-6xl px-4 py-10">
        <div className="mt-10 rounded-2xl border border-gray-200 bg-white p-6 text-sm text-gray-700">
          <p className="font-semibold text-gray-900">Not sure what you need?</p>
          <p className="mt-1 text-gray-600">
            Tell us your vehicle issue and we’ll recommend the right service.
          </p>
          <a
            href="/contact"
            className="mt-3 inline-flex text-sm font-semibold text-gray-900 hover:underline"
          >
            Contact us.
          </a>
        </div>
      </section>
    </main>
  );
};

export default Services;
